export class FileSnapshot {
    'snapshotId';
    'generatedOn';
    'expiresOn';
    'size';
    'modifiedOn';
    'modifiedBy';
    'mount';
    'inode';
    'etag';
    'snapshotType';
    'securityScan';
    'isInfected';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "snapshotId",
            "baseName": "snapshotId",
            "type": "string",
            "format": ""
        },
        {
            "name": "generatedOn",
            "baseName": "generatedOn",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "expiresOn",
            "baseName": "expiresOn",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "size",
            "baseName": "size",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "modifiedOn",
            "baseName": "modifiedOn",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "modifiedBy",
            "baseName": "modifiedBy",
            "type": "string",
            "format": ""
        },
        {
            "name": "mount",
            "baseName": "mount",
            "type": "string",
            "format": ""
        },
        {
            "name": "inode",
            "baseName": "inode",
            "type": "number",
            "format": ""
        },
        {
            "name": "etag",
            "baseName": "etag",
            "type": "string",
            "format": ""
        },
        {
            "name": "snapshotType",
            "baseName": "snapshotType",
            "type": "DBSnapshotType",
            "format": ""
        },
        {
            "name": "securityScan",
            "baseName": "securityScan",
            "type": "SecurityScan",
            "format": ""
        },
        {
            "name": "isInfected",
            "baseName": "isInfected",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return FileSnapshot.attributeTypeMap;
    }
    constructor() {
    }
}
